import type { IconProps } from './types';

export const MinusIcon: React.FC<IconProps> = (props) => {
    return (
        <svg {...props} id="ico-minus" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
            <path
                id="Path_5"
                data-name="Path 5"
                d="M1191.7-1170.227h10"
                transform="translate(-1188.705 1178.228)"
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
            />
            <rect id="Rectangle_5407" data-name="Rectangle 5407" width="16" height="16" fill="none" />
        </svg>
    );
};
